import type { ComponentPropsWithoutRef } from "react";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import type { BlockCategory } from "@circle-react-shared/BuilderUI/DataModel.types";
import { CategoryButton } from "./CategoryButton";

export interface BlockCategoryListProps extends ComponentPropsWithoutRef<"ul"> {
  categories: BlockCategory[];
  isReusableBlocksEnabled: boolean;
  onClickCategory: (category: BlockCategory) => void;
  selectedCategory?: BlockCategory;
  setShouldShowSavedBlocks: (show: boolean) => void;
  shouldShowSavedBlocks: boolean;
}

export const BlockCategoryList = ({
  categories,
  selectedCategory,
  onClickCategory,
  shouldShowSavedBlocks,
  setShouldShowSavedBlocks,
  isReusableBlocksEnabled,
}: BlockCategoryListProps) => (
  <OverlayScrollbarsComponent className="bg-secondary w-1/3">
    <ul className="flex list-none flex-col gap-1 px-4 py-5">
      {isReusableBlocksEnabled ? (
        <CategoryButton
          name="Saved blocks"
          nameI18n="builder_ui.block_list.saved_blocks"
          isActive={shouldShowSavedBlocks}
          onClick={() => setShouldShowSavedBlocks(true)}
        />
      ) : null}

      {categories.map(category => (
        <CategoryButton
          key={category.name}
          name={category.name}
          nameI18n={category.nameI18n}
          isActive={
            !shouldShowSavedBlocks && selectedCategory?.name === category.name
          }
          onClick={() => {
            onClickCategory(category);
            setShouldShowSavedBlocks(false);
          }}
        />
      ))}
    </ul>
  </OverlayScrollbarsComponent>
);
